interface GeoLocationResponse {
  status: string;
  country: string;
  countryCode: string;
  region: string;
  regionName: string;
  city: string;
  zip: string;
  lat: number;
  lon: number;
  timezone: string;
  isp: string;
  org: string;
  as: string;
  query: string;
}

const getGeolocation = async (): Promise<GeoLocationResponse | null> => {
  // List of free HTTPS geolocation services
  const services = [
    {
      url: 'https://ipapi.co/json/',
      transform: (data: any): GeoLocationResponse => ({
        status: 'success',
        country: data.country_name || '',
        countryCode: data.country_code || '',
        region: data.region_code || '',
        regionName: data.region || '',
        city: data.city || '',
        zip: data.postal || '',
        lat: data.latitude || 0,
        lon: data.longitude || 0,
        timezone: data.timezone || '',
        isp: data.org || '',
        org: data.org || '',
        as: data.asn || '',
        query: data.ip || '',
      }),
    },
    {
      url: 'https://ipwho.is/',
      transform: (data: any): GeoLocationResponse => ({
        status: data.success ? 'success' : 'fail',
        country: data.country || '',
        countryCode: data.country_code || '',
        region: data.region_code || '',
        regionName: data.region || '',
        city: data.city || '',
        zip: data.postal || '',
        lat: data.latitude || 0,
        lon: data.longitude || 0,
        timezone: data.timezone?.id || '',
        isp: data.connection?.isp || '',
        org: data.connection?.org || '',
        as: data.connection?.asn?.toString() || '',
        query: data.ip || '',
      }),
    },
  ];

  for (const service of services) {
    try {
      const response = await fetch(service.url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });

      if (!response.ok) continue;

      const data = await response.json();
      const result = service.transform(data);

      if (result.status === 'success' && result.countryCode) {
        return result;
      }
    } catch (error) {
      console.warn(`Geolocation service ${service.url} failed:`, error);
      continue;
    }
  }

  console.error('❌ All geolocation services failed');
  return null;
};

export default getGeolocation;